goog.provide("shadow.js.shim.module$$xyflow$react");
goog.provide("module$shadow_js_shim_module$$xyflow$react");
shadow.js.shim.module$$xyflow$react = shadow.js.nativeProvides["@xyflow/react"] = shadow$bridge("@xyflow/react");
module$shadow_js_shim_module$$xyflow$react.default = shadow.js.shim.module$$xyflow$react;
